import Plugin, { init } from "@/modules/_utils/Plugin";
import Swiper from "swiper";

export default () => {
  const productSlider = new Swiper("#blog__swiper-container", {
    effect: "slide",
    slidesPerView: 3,
    spaceBetween: 25,
    slidesPerGroup: 1,
    simulateTouch: false,
    allowTouchMove: false,
    speed: 700,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      575: {
        simulateTouch: true,
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 0
      },
      992: {
        simulateTouch: true,
        allowTouchMove: true,
        slidesPerView: 2,
        spaceBetween: 10
      }
    }
  });
};
